import React, { useRef, createContext, createRef } from "react";
export const GlobalRefContext = createContext(undefined);

const controlItems = [
  "ticker",
  "FairValueStrike",
  "FairValue1",
  "FairValue2",
  "horizon",
  "spiderTicker",
  "storedValueTicker",
  "storedValueHorizon",
];

const titleItems = [
  "fairvalue",
  "horizon",
  "oarvar",
  "relativeperformance",
  "storedvalue",
  "vectorset2",
  "vsfp",
];

export const GlobalRefProvider = ({ children }) => {
  const appRef = useRef(null);
  const renderRef = useRef({
    RelativePerformance: true,
    Horizon: false,
    VectorSet2: false,
    FairValue: false,
    OaRVaR: false,
    StoredValue: false,
    VSFP: false,
    BreakageAndReturn: false,
  });
  const tickerStorage = useRef({});
  const layout = useRef("");
  const titlePopup = useRef({});
  const storedValueStorage = useRef({});
  const layoutSaveName = useRef();
  const controlRefs = useRef(
    controlItems.reduce((a, b) => {
      return { ...a, [b]: createRef() };
    }, {})
  );
  const controlPositions = useRef(
    controlItems.reduce((a, b) => {
      return { ...a, [b]: {} };
    }, {})
  );
  const titleRefs = useRef(
    titleItems.reduce((a, b) => {
      return { ...a, [b]: createRef() };
    }, {})
  );

  const titlePositions = useRef(
    titleItems.reduce((a, b) => {
      return { ...a, [b]: {} };
    }, {})
  );

  const refs = {
    appRef,
    renderRef,
    tickerStorage,
    layout,
    storedValueStorage,
    layoutSaveName,
    controlRefs,
    controlPositions,
    titlePositions,
    titleRefs,
    titlePopup,
  };

  return refs ? (
    <GlobalRefContext.Provider value={refs}>
      {children}
    </GlobalRefContext.Provider>
  ) : null;
};
